module.exports = __webpack_public_path__ + "media/entities/2301-ad1b5b19.png";